import { render, staticRenderFns } from "./homebox.vue?vue&type=template&id=2744af5e&scoped=true"
import script from "./homebox.vue?vue&type=script&lang=js"
export * from "./homebox.vue?vue&type=script&lang=js"
import style0 from "./homebox.vue?vue&type=style&index=0&id=2744af5e&prod&scoped=true&lang=scss"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2744af5e",
  null
  
)

export default component.exports